import { useSuspenseQuery } from "@apollo/client";

import { MapEditorObservationPanelObservationEditableDocument } from "./queries.generated";

export function useSuspenseObservationEditableQuery(mapEditorFeatureId: string) {
    return useSuspenseQuery(MapEditorObservationPanelObservationEditableDocument, {
        variables: { mapEditorFeatureId },
    });
}
